"use client";

import { usePathname } from "next/navigation";
import { getRegisterUrl } from "@/lib/registration-source";

export function useRegisterUrl(src?: string | null): string {
  const pathname = usePathname();

  return getRegisterUrl({ pathname, src });
}
